export default __webpack_public_path__ + "static/media/manage-user.0c0dcf9d.svg";